export default "<app-info-vehicle></app-info-vehicle>";